import { css } from 'lit';
// language=CSS
export default css`
  :host {
    height: 100%;
  }

  ki-menu::part(menu-item) {
    border: 0px;
    padding: 0px 10px;
    font-weight: bold;
    color: var(--theme-color-primary);
  }

  ki-menu::part(sub-menu-item) {
    color: white;
    font-weight: bold;
  }


  ki-menu::part(menu-icon) {
    fill: white;
    border: 0px;
    margin-bottom: 3px;
    color: var(--theme-color-primary);
    fill: var(--theme-color-primary);
  }

  ki-menu::part(expand-icon) {
    fill: white;
  }
 .app-name {
   font-size: 22px;
   font-weight: bold;
   color: var(--theme-color-primary);
   align-self: center;
 }

 .app-name.mobile {
   font-size: 16px;
 }

  .header {
    height: 60px;
    box-shadow: 0 1px 3px rgb(0 0 0 / 16%), 0 1px 3px rgb(0 0 0 / 23%);
    z-index: 999;
  }

  .nav {
    height: 50px;
  }

  .logo-left {
    width: 140px;
    margin-right: 40px;
  }

  .logo-left.mobile {
    margin-right: 10px;
  }

  .logo-left img {
    height: 85%;
    padding: 3px;
  }

  .logo-right img {
    height: 85%;
    padding: 3px;
  }

  .drawer {
    background: transparent;
  }

  .footer {
    background: var(--theme-color-primary);
    width: 100%;
    display: flex;
    justify-content: space-between;
    color: white;
    padding: 3px 0;
    font-size: 0.9em;
  }

  .footer-left {
    padding-left: 10px;
    padding-right: 10px;
  }
  .footer-right {
    padding-right: 10px;
    text-align: end;
  }

  :host(.sm-screen) .footer-left,
  :host(.sm-screen) .footer-right {
    display: none;
  }

  .footer-mobile {
    display: none;
  }

  :host(.sm-screen) .footer-mobile {
    width: 100%;
    display: flex;
    justify-content: space-between;
    padding-right: 10px;
    padding-left: 10px;
  }

  /* Tooltip container */
.tooltip {
  position: relative;
  display: inline-block;
  font-weight: bold;
}

.tooltip .tooltiptext {
  visibility: hidden;
  width: 180px;
  background-color: #555;
  color: #fff;
  text-align: center;
  font-size: 12px;
  font-weight: normal;
  padding: 5px;
  border-radius: 6px;
  position: absolute;
  z-index: 1;
  bottom: 125%;
  left: 50%;
  margin-left: -60px;
  opacity: 0;
  transition: opacity 0.3s;
}

.tooltip:hover .tooltiptext {
  visibility: visible;
  opacity: 1;
}

`;
